export var valuesVerticalAlignment = ["Top", "Center", "Bottom"];
/*

*/ 
//# sourceMappingURL=VerticalAlignment.js.map